import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { COLORS, hex2rgba } from '../../styles';

export const List = styled.ul`
  margin: 0;
  padding: 8px;
  list-style: none;
`;

export const Item = styled.li<{ isSelected?: boolean }>`
  color: ${COLORS.gray80};
  border-radius: 8px;
  cursor: pointer;
  ${({ isSelected }) => isSelected &&
    css`
      color: ${COLORS.blue60};
      background: ${hex2rgba(COLORS.slategray10, 0.5)};
    `}
`;

export const ItemRow = styled.div<{ hasBorder?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 32px;
  padding: 0 8px;
  border-radius: 8px;
  ${({ hasBorder }) => hasBorder &&
    `
  box-shadow: inset 0 0 0 1px ${COLORS.blue40};
  `}
`;

const IconStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  margin: 0 2px;
  font-size: 16px;
  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }
`;

export const Icon = styled.div(IconStyles);

export const IconButton = styled.button<{
  width?: number,
  hidden?: boolean,
}>`
  ${IconStyles};
  padding: 0;
  color: ${COLORS.slategray40};
  border: 0;
  background: none;
  ${({ width }) => width && `width: ${width}px;`}
  ${({ hidden }) => hidden &&
    `
    visibility: hidden;
    pointer-events: none;
  `}
  &:hover,
  &:focus {
    color: ${COLORS.slategray60};
  }
`;

export const Label = styled.div<{
  bold?: boolean,
  error?: boolean,
  lineThrough?: boolean,
}>`
  overflow: hidden;
  flex: 1;
  padding-left: 6px;
  font-size: 11px;
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  line-height: 31px;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ error }) => error && css`
    color: red;
    opacity: .8;
    &:after {
      content: " - " attr(data-error) "(!)";
      font-size: 10px;
      font-weight: bold;
    }
  `}
  ${({ lineThrough }) => lineThrough && css`
    opacity: .8;
    text-decoration: line-through;
  `}
`;

export const SubList = styled.ul<{ hasLeftBorder?: boolean }>`
  position: relative;
  padding-left: 14px;
  list-style: none;
  ${({ hasLeftBorder }) => hasLeftBorder &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 13px;
        bottom: 8px;
        width: 2px;
        background: rgba(0, 0, 0, 0.04);
      }
    `}
`;
